import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/styles/makeStyles';
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AvailableSummary from './AvailableSummary';
import StockMovement from './StockMovement';
import StorageReport from './StorageReport';

const useStyles = makeStyles(theme => ({
    root: props => ({
        margin: props.isDesktop ? theme.spacing(3) : theme.spacing(1.5)
    }),
    header: {
        marginBottom: theme.spacing(2)
    },
    tabBar: {
        borderRadius: theme.shape.borderRadius,
        marginBottom: theme.spacing(2)
    },
    panel: {
        // Keep child pages flush with the page container; they bring their
        // own spacing, so we only need a small top gap here.
        marginTop: theme.spacing(1)
    }
}));

const StockOverview = ({ showError, showMessage, history, match, isLine }) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const classes = useStyles({ isDesktop });
    const [tabIndex, setTabIndex] = useState(0);

    const childProps = { showError, showMessage, history, match, isLine };

    const renderTab = () => {
        switch (tabIndex) {
            case 0:
                return <AvailableSummary {...childProps} />;
            case 1:
                return <StockMovement {...childProps} />;
            case 2:
                return <StorageReport {...childProps} />;
            default:
                return null;
        }
    };

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <Typography variant="h3">Medicines &amp; Feed</Typography>
                <Typography variant="body2" color="textSecondary">
                    Available stock, movement to sheds, and storage reports
                </Typography>
            </div>
            <Paper className={classes.tabBar} elevation={1}>
                <Tabs
                    value={tabIndex}
                    indicatorColor="primary"
                    textColor="primary"
                    variant={isDesktop ? 'standard' : 'fullWidth'}
                    onChange={(event, newValue) => setTabIndex(newValue)}
                >
                    <Tab label="Available" />
                    <Tab label="Movement" />
                    <Tab label="Report" />
                </Tabs>
            </Paper>
            <div className={classes.panel}>{renderTab()}</div>
        </div>
    );
};

export default StockOverview;
